import { render, staticRenderFns } from "./RoleCard.vue?vue&type=template&id=0a3006d4&scoped=true"
import script from "./RoleCard.vue?vue&type=script&lang=js"
export * from "./RoleCard.vue?vue&type=script&lang=js"
import style0 from "./RoleCard.vue?vue&type=style&index=0&id=0a3006d4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3006d4",
  null
  
)

export default component.exports